<template>
  <layout-main-inner title="内容管理">
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">
        <el-button
          slot="action"
          type="primary"
          size="small"
          @click="create">新增内容</el-button>
      </template>
      <div slot="form">
        <!-- <el-radio-group
          v-model="config.contentTypes"
          @change="fetchList">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="[0]">多图</el-radio-button>
          <el-radio-button :label="[1]">公众号链接</el-radio-button>
          <el-radio-button :label="[6]">视频素材</el-radio-button>
        </el-radio-group> -->
        <!-- <el-button
          type="primary"
          @click="fetchList">刷新</el-button> -->
        <el-input
          v-model="config.title"
          clearable
          placeholder="请输入内容标题"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
      <el-table
        border
        :data="list">
        <el-table-column
          label="内容标题"
          min-width="140">
          <template slot-scope="{row}">
            <!-- <link-route :link-to="`/wxapp-message-detail?msgId=${row.msgId}&vendorId=${row.vendorId}`"> -->
            {{ row.title }}
            <!-- </link-route> -->
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="内容类型"
          width="100">
          <template slot-scope="{row}">
            <span v-if="row.contentType === 0">多图</span>
            <span v-if="row.contentType === 1">公众号链接</span>
            <span v-if="row.contentType === 6">视频素材</span>
          </template>
        </el-table-column> -->
        <el-table-column
          min-width="240"
          label="内容说明"
          prop="content.brief"></el-table-column>
        <el-table-column
          label="最近发布时间"
          width="140">
          <template slot-scope="{row}">
            <span>{{ row.pubTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="浏览次数"
          width="80"
          prop="viewCount"></el-table-column>
        <el-table-column
          label="状态"
          width="80">
          <template slot-scope="{row}">
            <span>{{ row.status | statusFormat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="{row}">
            <el-button
              type="text"
              @click="update(row)">编辑</el-button>
            <el-button
              type="text"
              @click="deleteRow(row)">删除</el-button>
            <!-- <el-dropdown>
              <el-button type="warning">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="row.status !== 2"
                  @click.native="deleteRow(row)">删除</el-dropdown-item>
                <el-dropdown-item
                  @click.native="update(row)">编辑</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination
          slot="footer"
          background
          :current-page.sync="config.pageNum"
          :page-size="config.pageSize"
          layout="total, prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange">  </el-pagination>
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'WxappMessageIndex',
  components: {},
  filters: {
    statusFormat(value) {
      const status = { 0: '草稿', 1: '未发布', 2: '已发布' }
      return status[value]
    }
  },
  props: {},
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, contentTypes: [100], title: '' }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.config.vendorId = this.userInfo.orgId
    this.fetchList()
  },
  methods: {
    update(row) {
      this.$router.push(`/wxapp-solution-edit?msgId=${row.msgId}&vendorId=${row.vendorId}`)
    },
    create() {
      this.$router.push('/wxapp-solution-edit?vendorId=' + this.userInfo.orgId)
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('portal/getmessages', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => ({ ...i, content: JSON.parse(i.content) }))
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteRow(row) {
      this.$confirm('您确定删除该条内容?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('portal/deletemessage', {
            payload: { vendorId: row.vendorId, msgId: row.msgId },
            success: (res) => {
              console.log(res)
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    }
  }
}
</script>
